import "./App.css";
import { Route, Routes } from "react-router-dom";
import { Home, Product, Cart, Wishlist, User } from "./pages";
import { Register } from "./pages/user/Register";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/user" element={<User />} />
        <Route path="register" element={<Register />} />
      </Routes>
    </div>
  );
}

export default App;
